// extracted by mini-css-extract-plugin
export default {"container":"LiveLesson_container__t0kIF"};